@if (enabled) {
  <a mat-fab extended color="primary" [class.has-tabs]="hasTabs" [class.has-drafts]="hasOpenDrafts" (click)="onClick()">
    <mat-icon>add</mat-icon>
    {{label}}
  </a>
}
